//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DateTime } from 'luxon'

export default {
  props: {
    months: Array,
    turmasLength: Number,
  },
  data() {
    return {
      DateTime,
      calendarDialog: false,
      pickerDate: null,
    }
  },
  methods: {
    getDates(m) {
      let dates = []
      for (let index = 0; index < this.turmasLength; index++) {
        dates.push(m['dates' + (index + 1)])
      }
      return dates.flat()
    },
    setColor(date, month) {
      if (month['dates1'].includes(date)) return '#2d386d'
      if (month['dates2'].includes(date)) return '#dfc139'
      if (month['dates3'].includes(date)) return '#888'
      return false
    },
  },
  computed: {
    setMaxWidth() {
      if (this.months && this.months.length) {
        let arrL = this.months.length > 4 ? 4 : this.months.length
        let w = 48 + 24 + arrL * 314
        return w + 'px'
      }

      return ''
    },
  },
  mounted() {
    this.$nuxt.$on('open-calendar', () => {
      this.calendarDialog = true
    })
  },
}
